import { Component, Inject, OnInit , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_707';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Indique el valor  ', listHelp: ['777'] }
];

@Component({
  selector: 'app-ganancias-ocasionales-premios-titulos-modal',
  templateUrl: './ganancias-ocasionales-premios-titulos-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-premios-titulos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
    
  ]
})
export class GananciasOcasionalesPremiosTitulosModalComponent extends HandlerModal implements OnInit {

  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dialogRef: MatDialogRef<GananciasOcasionalesPremiosTitulosModalComponent>,
    public dNotificacionServicio:DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {  
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_777 == undefined)this.model.doc.cuerpo.cs_id_777="0";
    if(this.model.doc.cuerpo.cs_id_778 == undefined)this.model.doc.cuerpo.cs_id_778="0";
    if(this.model.doc.cuerpo.cs_id_707 == undefined)this.model.doc.cuerpo.cs_id_707="0";
    
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 777: this.OperacionCs777(); break;  
      case 778: this.OperacionCs778(); break;   

             
   }
    if(soloEstaCasilla)return;

    //Operaciones3
    let resultado = "0";
    
  }
//valor del premio por titulos
OperacionCs777(){
 const  cas777 = this.model.doc.cuerpo.cs_id_777;
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas777,"0")) {
   this.dNotificacionServicio.mostrarDialogoInformacion("El valor del premio no puede ser cero");
   return
  }
  this.OperacionCs784();
}

OperacionCs778(){
  const  cas777 = this.model.doc.cuerpo.cs_id_777;
  const  cas778 = this.model.doc.cuerpo.cs_id_778;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas777,cas778)) {
    this.dNotificacionServicio.mostrarDialogoInformacion("El valor No puede ser mayor a la casilla del valor del premio ");
    return
   }
   this.OperacionCs784();
 }
//Calculo de impuesto de ganacia ocasional al 20%
OperacionCs784(){
  //validacion pendiente
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    this.model.doc.cuerpo.cs_id_777="0";
    this.model.doc.cuerpo.cs_id_778="0";
    this.model.doc.cuerpo.cs_id_707="0";
    this.model.doc.cuerpo.cs_id_776=null;
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-titulos-modal/ganancias-ocasionales-premios-titulos-modal.component.ts